<template>
    <div class="purchase">
        <div class="purchase-vip">
            <ul class="purchase-vip-ul">
                <li class="purchase-vip-07" @click="boss">
                    <div class="purchase-imgs">
                        <img src="../../assets/imags/purchase1.png" alt="" />
                        <div class="purchase-tet">我是老板</div>
                    </div>
                    <p>加盟我们成为老板让您轻松做无货源跨境电商。</p>
                </li>
                <li class="purchase-vip-fa" @click="yuangong">
                    <div class="purchase-imgs">
                        <img src="../../assets/imags/purchase2.png" alt="" />
                        <div class="purchase-tet">我是员工</div>
                    </div>
                    <p>梦想的起点从这里开始。我能行！</p>
                </li>
                <li class="purchase-vip-fd" @click="tiyan">
                    <div class="purchase-imgs">
                        <img src="../../assets/imags/purchase3.png" alt="" />
                        <div class="purchase-tet">我要体验</div>
                    </div>
                    <p>7天体验，让您体验不一样的管理运营模式。</p>
                </li>
            </ul>
        </div>
        <div class="purchase-function purchase-vip">
            <h6>海逊·特色功能</h6>
            <ul class="purchase-function-ul">
                <li>
                    <div class="purchase-function-img">
                        <img src="../../assets/imags/purchase4.png" alt="" />
                    </div>
                    <div class="purchase-function-tet">一站式跨境电商服务</div>
                </li>
                <li>
                    <div class="purchase-function-img">
                        <img src="../../assets/imags/purchase5.png" alt="" />
                    </div>
                    <div class="purchase-function-tet">无货源跨境ERP</div>
                </li>
                <li>
                    <div class="purchase-function-img">
                        <img src="../../assets/imags/purchase6.png" alt="" />
                    </div>
                    <div class="purchase-function-tet">亚马逊电商培训</div>
                </li>
                <li>
                    <div class="purchase-function-img">
                        <img src="../../assets/imags/purchase7.png" alt="" />
                    </div>
                    <div class="purchase-function-tet">国际物流服务</div>
                </li>
            </ul>
        </div>
        <!-- 客服 -->
        <div class="purchase-service">
            <div class="purchase-service-imgs">
                <img src="../../assets/imags/purchase8.png" alt="" />
            </div>
            <div class="purchase-service-mobile">
                <img src="../../assets/imags/purchase9.png" alt="" />
                <div class="service-content">全国免费电话</div>
            </div>
            <div class="service-mobile">0351-5222058</div>
            <div class="service-bottom">在线咨询</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "index",
    data() {
        return {
            // collection: true
        };
    },
    components: {},
    mounted() {},
    created() {},
    methods: {
        boss() {
            this.$router.push({ path: "/dashboard/analysis" });
        },
        yuangong() {
            this.$router.push("/list");
        },
        tiyan() {
            this.$router.push("/HelloWorld");
        },
    },
};
</script>

<style lang="scss" scoped>
.purchase {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .purchase-vip {
        width: 100%;
        height: auto;
        overflow: hidden;
        background: #f7f7f7;
        .purchase-vip-ul {
            width: 75%;
            height: 100%;
            overflow: hidden;
            margin: 4% auto 4%;
            padding: 2% 0;
            li {
                overflow: hidden;
                width: 18%;
                height: 180px;
                padding: 20px 30px;
                border-radius: 10px;
                float: left;
                margin-left: 11%;
                .purchase-imgs {
                    overflow: hidden;
                    img {
                        width: 50px;
                        height: 50px;
                        float: left;
                    }
                    .purchase-tet {
                        float: left;
                        line-height: 60px;
                        font-size: 28px;
                        color: #fff;
                        margin-left: 6%;
                    }
                }
                p {
                    display: block;
                    width: 100%;
                    line-height: 30px;
                    color: #fff;
                    font-size: 18px;
                    letter-spacing: 1.5px;
                    margin-top: 1%;
                }
            }
            li:hover {
                box-shadow: 0px 5px 20px 7px rgba(131, 131, 131, 0.41);
            }
            .purchase-vip-07 {
                background: #07add7;
                margin-left: 2%;
            }
            .purchase-vip-fa {
                background: #facd02;
            }
            .purchase-vip-fd {
                background: #fd6969;
            }
        }
    }
    .purchase-function {
        margin-top: 3%;
        h6 {
            text-align: center;
            line-height: 100px;
            font-size: 30px;
            letter-spacing: 2px;
        }
        .purchase-function-ul {
            width: 75%;
            margin: 3% auto 10%;
            justify-content: space-around;
            display: flex;
            li {
                width: 20%;
                .purchase-function-img {
                    width: 150px;
                    height: 150px;
                    border-radius: 50%;
                    box-shadow: 0px 15px 32px 6px rgba(131, 131, 131, 0.15);
                    margin: auto;
                    img {
                        width: 100px;
                        height: 100px;
                        padding: 25px;
                    }
                }
                .purchase-function-tet {
                    line-height: 60px;
                    font-size: 18px;
                    text-align: center;
                }
            }
        }
    }
    .purchase-service {
        position: fixed;
        top: 30%;
        width: 130px;
        height: 300px;
        right: 3%;
        background-image: url("../../assets/imags/purchase10.png");
        background-size: 100% 100%;
        .purchase-service-imgs {
            width: 100px;
            height: 100px;
            background: #fff;
            border-radius: 50%;
            margin: 26px 15px 20px;
            img {
                width: 80px;
                height: 80px;
                padding: 10px;
            }
        }
        .purchase-service-mobile {
            overflow: hidden;
            // width: 100%;
            padding: 0 10px;
            img {
                width: 23px;
                float: left;
            }
            .service-content {
                float: left;
                color: #fff;
            }
        }
        .service-mobile {
            // width: 100%;
            line-height: 50px;
            color: #fff;
            text-align: center;
            padding: 0 10px;
        }
        .service-bottom {
            width: 80%;
            margin: auto;
            text-align: center;
            background: #fff;
            line-height: 30px;
            color: #2c8dff;
            border-radius: 5px;
        }
    }
}
</style>
